import React from "react";
import { Link } from "react-router-dom";
import { ASSETS, SOCIAL } from "../lib/assets";
import { Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-[var(--pc-line)] bg-[var(--pc-bg)]"
    >
      <div className="pc-container py-16 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-9 md:gap-10 text-center md:text-left">
          <Link
            to="/"
            data-testid="footer-logo-link"
            className="inline-flex justify-self-center md:justify-self-start"
            aria-label="Inicio Paco Cabrera"
          >
            <img
              data-testid="footer-logo"
              src={ASSETS.logoWhite}
              alt="Paco Cabrera · Arquitectura y Permanencia"
              className="h-20 md:h-28 w-auto"
              draggable="false"
            />
          </Link>

          <div className="flex items-center justify-center gap-8 md:gap-14 flex-wrap">
            <a
              data-testid="social-instagram"
              href={SOCIAL.instagram}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 nav-link"
            >
              <Instagram size={16} strokeWidth={1.1} />
              <span>Instagram</span>
            </a>
            <a
              data-testid="social-youtube"
              href={SOCIAL.youtube}
              target="_blank"
              rel="noreferrer"
              className="flex items-center gap-3 nav-link"
            >
              <Youtube size={18} strokeWidth={1.1} />
              <span>YouTube</span>
            </a>
          </div>

          <div className="label-small text-[var(--pc-text-mute)] md:justify-self-end justify-self-center">
            © 2026 Paco Cabrera
          </div>
        </div>
      </div>
    </footer>
  );
}
